var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        {
          staticClass: "mb-12"
        },
        [
          _c("gg-card-header", [_vm._v(" Home Page Section ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          " Please provide the content that you would like to place on your website’s home page. "
                        )
                      ]),
                      _c("v-textarea", {
                        attrs: {
                          label:
                            "Provide content for Your Website's Home Section",
                          rows: "4",
                          name: "content-home",
                          outlined: "",
                          autocomplete: "new-password",
                          "data-vv-as": "Home Section Content",
                          "error-messages": _vm.errors.collect("content-home")
                        },
                        model: {
                          value: _vm.contentHome,
                          callback: function callback($$v) {
                            _vm.contentHome = $$v
                          },
                          expression: "contentHome"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "gg-card",
        {
          staticClass: "mb-12"
        },
        [
          _c("gg-card-header", [_vm._v(" About Us Section ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          " Please provide the content that you would like to place on your website’s about us page. "
                        )
                      ]),
                      _c("v-textarea", {
                        attrs: {
                          label:
                            "Provide content for Your Website's About Section",
                          rows: "4",
                          name: "content-about",
                          outlined: "",
                          autocomplete: "new-password",
                          "data-vv-as": "About Section Content",
                          "error-messages": _vm.errors.collect("content-about"),
                          hint: ""
                            .concat(
                              _vm.contentAboutLength.wordsAvailable,
                              " words left out of "
                            )
                            .concat(
                              _vm.contentAboutLength.maxWordsNumber,
                              " possible"
                            )
                        },
                        model: {
                          value: _vm.contentAbout,
                          callback: function callback($$v) {
                            _vm.contentAbout = $$v
                          },
                          expression: "contentAbout"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "gg-card",
        {
          staticClass: "mb-12"
        },
        [
          _c("gg-card-header", [_vm._v(" Products & Services ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          " Please provide up to 6 products and services. "
                        )
                      ]),
                      _vm._l(_vm.services, function(service, index) {
                        return [
                          _c("v-textarea", {
                            key: "service-".concat(index),
                            attrs: {
                              label:
                                "Provide content for Your Website's Services or Products Section",
                              rows: "4",
                              name: "content-services".concat(index),
                              outlined: "",
                              autocomplete: "new-password",
                              "data-vv-as": "Services Section Content",
                              "error-messages": _vm.errors.collect(
                                "content-services".concat(index)
                              )
                            },
                            model: {
                              value: _vm.services[index],
                              callback: function callback($$v) {
                                _vm.$set(_vm.services, index, $$v)
                              },
                              expression: "services[index]"
                            }
                          })
                        ]
                      }),
                      _vm.canAddService
                        ? _c(
                            "gg-btn",
                            {
                              attrs: {
                                text: ""
                              },
                              on: {
                                click: _vm.addServiceProduct
                              }
                            },
                            [_vm._v(" Add Item ")]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "gg-card",
        {
          staticClass: "mb-12"
        },
        [
          _c("gg-card-header", [_vm._v(" Your Business Location ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("gg-text-field", {
                        attrs: {
                          label: "Your Business Address",
                          name: "address",
                          outlined: "",
                          autocomplete: "new-password",
                          "data-vv-as": "Business Address",
                          "error-messages": _vm.errors.collect("address")
                        },
                        model: {
                          value: _vm.businessAddress,
                          callback: function callback($$v) {
                            _vm.businessAddress = $$v
                          },
                          expression: "businessAddress"
                        }
                      }),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "6"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                attrs: {
                                  label: "City",
                                  name: "city",
                                  outlined: "",
                                  autocomplete: "new-password",
                                  "data-vv-as": "City",
                                  "error-messages": _vm.errors.collect("city")
                                },
                                model: {
                                  value: _vm.city,
                                  callback: function callback($$v) {
                                    _vm.city = $$v
                                  },
                                  expression: "city"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "6"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                attrs: {
                                  label: "Zipcode",
                                  name: "zipcode",
                                  outlined: "",
                                  autocomplete: "new-password",
                                  "data-vv-as": "Zipcode",
                                  "error-messages": _vm.errors.collect(
                                    "zipcode"
                                  )
                                },
                                model: {
                                  value: _vm.zipcode,
                                  callback: function callback($$v) {
                                    _vm.zipcode = $$v
                                  },
                                  expression: "zipcode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("gg-select", {
                        attrs: {
                          label: "Select Your Country",
                          name: "country",
                          outlined: "",
                          items: _vm.countries,
                          "item-text": "name",
                          "item-value": "name",
                          "data-vv-as": "Country",
                          "error-messages": _vm.errors.collect("country")
                        },
                        model: {
                          value: _vm.country,
                          callback: function callback($$v) {
                            _vm.country = $$v
                          },
                          expression: "country"
                        }
                      }),
                      _c("gg-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "email",
                            expression: "'email'"
                          }
                        ],
                        attrs: {
                          label: "Provide the Company Email Address",
                          name: "email",
                          outlined: "",
                          autocomplete: "new-password",
                          "data-vv-as": "Email Address",
                          "error-messages": _vm.errors.collect("email")
                        },
                        model: {
                          value: _vm.email,
                          callback: function callback($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      }),
                      _c("gg-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "phone",
                            expression: "'phone'"
                          }
                        ],
                        attrs: {
                          label: "Provide the Company Phone Number",
                          name: "phone",
                          outlined: "",
                          autocomplete: "new-password",
                          "data-vv-as": "Phone Number",
                          "error-messages": _vm.errors.collect("phone")
                        },
                        model: {
                          value: _vm.phone,
                          callback: function callback($$v) {
                            _vm.phone = $$v
                          },
                          expression: "phone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "gg-card",
        {
          staticClass: "mt-6"
        },
        [
          _c("gg-card-header", [_vm._v(" Business Hours ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "v-form",
                        [
                          _c("v-switch", {
                            attrs: {
                              "true-value": 1,
                              "false-value": 0,
                              label: "My business has hours"
                            },
                            model: {
                              value: _vm.businessHours,
                              callback: function callback($$v) {
                                _vm.businessHours = $$v
                              },
                              expression: "businessHours"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.businessHours ? _c("work-schedule") : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }